import React from 'react';
import styles from './HistoricalRiskDashboardPage.module.scss';
import { Outline } from '@otcmarketsgroup/otcm-ui';
import { HeadTitle } from '../../components/HeadTitle';
import { HistoricRiskDataGrid } from '../../components/HistoricRiskDataGrid';
import { HistoricalRiskDashboardFilter } from '../HistoricalRiskDashboardFilter';
import { TabNav } from '../../components/TabNav';
import { PAGE_TAB_ITEMS, ECN_RISK_SUMMARY, IDQS_RISK_SUMMARY } from '../../util/dashBoardPageConstants';
import getConfig from '../../config';
const { RISK_DASHBOARD_CONFIG } = getConfig();
const ECN_RISK_CONFIG = RISK_DASHBOARD_CONFIG.get(ECN_RISK_SUMMARY);
const IDQS_RISK_CONFIG = RISK_DASHBOARD_CONFIG.get(IDQS_RISK_SUMMARY);

class HistoricalRiskDashboardPage extends React.PureComponent {
  constructor (props) {
    super(props);
    this.state = {
      title: 'Historical Risk Monitoring',
      queryParam: {}
    };
    this.setQueryParameters = this.setQueryParameters.bind(this);
  }

  setQueryParameters (queryParamObj) {
    // this.clear();
    // start the loading icon
    this.setState({ isSearching: true });
    // get only specific trades
    this.setState({ queryParam: queryParamObj }, this.loadData);
  }

  render () {
    return (
      <div key={'historicalRiskDashboardPage'} >
        <HeadTitle title={this.state.title} />
        <div className={styles.tabControlsContainer}>
          <TabNav tabItems={PAGE_TAB_ITEMS} />
        </div>
        <HistoricalRiskDashboardFilter search={this.setQueryParameters} />
        {this.state.isSearching && <div className={styles.grids}>
          <div id='ecnRiskDiv'>
            <Outline
              mode='headingSmall'
              bottomBorderOnly={false}
              topBorderOnly={false}
              className={styles.contentHeader}
            >ECN</Outline>
            <HistoricRiskDataGrid
              key={ECN_RISK_CONFIG.identifier}
              identifier={ECN_RISK_CONFIG.identifier}
              header={ECN_RISK_CONFIG.header}
              api={ECN_RISK_CONFIG.historicApi}
              downloadApi={ECN_RISK_CONFIG.downloadApi}
              filter={this.state.queryParam}
              columns={ECN_RISK_CONFIG.histColumns}
              totalField={ECN_RISK_CONFIG.totalField}
              summaryGroupTitleColumn={ECN_RISK_CONFIG.summaryGroupTitleColumn}
              summaryGroupDataColumn={ECN_RISK_CONFIG.summaryGroupDataColumn}
              maxRows={20} />
          </div>
          <div id='idqsRiskDiv'>
            <Outline
              mode='headingSmall'
              bottomBorderOnly={false}
              topBorderOnly={false}
              className={styles.contentHeader}
            >IDQS</Outline>
            <HistoricRiskDataGrid
              key={IDQS_RISK_CONFIG.identifier}
              identifier={IDQS_RISK_CONFIG.identifier}
              header={IDQS_RISK_CONFIG.header}
              api={IDQS_RISK_CONFIG.historicApi}
              downloadApi={IDQS_RISK_CONFIG.downloadApi}
              filter={this.state.queryParam}
              columns={IDQS_RISK_CONFIG.histColumns}
              totalField={IDQS_RISK_CONFIG.totalField}
              summaryGroupTitleColumn={IDQS_RISK_CONFIG.summaryGroupTitleColumn}
              summaryGroupDataColumn={IDQS_RISK_CONFIG.summaryGroupDataColumn}
              maxRows={20} />
          </div>
        </div> }

      </div>
    );
  }
}

export default HistoricalRiskDashboardPage;
